<script setup lang="ts">
import { PracticasItem } from '~/api/drupal'
import { useI18n } from 'vue-i18n'

defineProps<{
  item: PracticasItem
}>()

const { t } = useI18n()
</script>
<template>
  <div class="item">
    <div class="wrap details">
      <h2 class="company f-28">{{ item.company }}</h2>
      <p class="city f-18">{{ item.city }}</p>
      <span class="education f-18 f-bold">{{ item.cbzEducation }}</span>
    </div>
    <PracticaBlock :title="t('practicas.list.internshipLabel')" :item="item.internship" :has-toggle="false" />
    <PracticaBlock :title="t('practicas.list.employmentLabel')" :item="item.employment" :has-toggle="true" />
  </div>
</template>
<style scoped lang="scss">
.item {
  background: var(--c-background-light);
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  .wrap {
    padding: 32px 40px;
    border-top: 1px solid var(--c-line-light);
    &:first-child {
      border-top: none;
      padding-top: 40px;
    }
  }
  .company {
    margin-bottom: 4px;
  }
  .city {
    margin-bottom: 0;
    color: var(--c-gray-75);
  }
  .education {
    display: block;
    margin-top: 24px;
    margin-bottom: 0;
    color: var(--c-primary);
  }
}
</style>
